export default __webpack_public_path__ + "static/media/bottomfish_fisher_user_guide.fe594888.pdf";